import { render, staticRenderFns } from "./EducationalGroupAddStudents.vue?vue&type=template&id=38bced38&"
import script from "./EducationalGroupAddStudents.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupAddStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports